<template>
    <div class="sale">
        <el-form :model="searchData" :inline="true" size="small">
            <el-form-item v-if="searchData.type_id == 2">
                <el-select size="small" v-model="searchData.user_id" placeholder="销售员" clearable>
                    <el-option
                        v-for="item in userData.list"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-input
                    v-model="searchData.customer_name"
                    placeholder="客户名称/联系人"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-input
                    v-model="searchData.contact_mobilephone"
                    placeholder="手机号"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-select
                    v-model="searchData.express_type_id"
                    placeholder="发货方式"
                    multiple
                    collapse-tags
                    clearable
                >
                    <el-option-group
                        :key="group.label"
                        :label="group.label"
                        v-for="group in $store.state.expressInfo.list"
                    >
                        <el-option
                            :key="item.key"
                            :label="item.value"
                            :value="item.key"
                            v-for="item in group.options"
                        ></el-option>
                    </el-option-group>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select
                    v-model="searchData.order_status_id"
                    placeholder="订单状态"
                    multiple
                    collapse-tags
                    clearable
                >
                    <el-option
                        v-for="row in $store.state.orderInfo.list"
                        :key="row.key"
                        :label="row.value"
                        :value="row.key"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="searchData.deliver_type_id" placeholder="发货方式" clearable>
                    <el-option :key="1" label="立即发货" :value="1"></el-option>
                    <el-option :key="2" label="延迟发货" :value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="searchData.is_econciliation" placeholder="对账状态" clearable>
                    <el-option
                        v-for="row in $store.state.econciliationInfo.list"
                        :key="row.key"
                        :label="row.value"
                        :value="row.key"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-date-picker
                    v-model="searchData.timer"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    align="right"
                    unlink-panels
                    clearable
                    :picker-options="pickerOptions"
                    :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button plain icon="el-icon-search" @click="SearchOrder">搜索</el-button>
            </el-form-item>
        </el-form>
        <div class="card">
            <div class="list" v-loading="orderData.loading.list">
                <el-row class="list-control">
                    <el-col :span="$store.state.userInfo.identity === 1 ? 12 : 24">
                        <el-radio-group
                            size="small"
                            v-model="searchData.type_id"
                            @change="SearchOrder"
                        >
                            <el-radio-button :label="1">我的订单</el-radio-button>
                            <el-radio-button
                                :label="2"
                                v-if="
                                    $store.state.userInfo.identity === 1 ||
                                    $store.state.userInfo.identity === 2
                                "
                                >全部订单</el-radio-button
                            >
                        </el-radio-group>
                    </el-col>
                    <el-col :span="12" class="t-right">
                        <template v-if="!searchData.type_id">
                            <el-popover placement="bottom-end" width="186" trigger="hover">
                                <canvas id="qrcode" style="width: 160px; height: 160px"></canvas>
                                <el-button
                                    size="small"
                                    slot="reference"
                                    :disabled="!selectionData.list.length"
                                    >批量支付</el-button
                                >
                            </el-popover>
                        </template>
                        <template
                            v-if="$store.state.userInfo.identity === 1 && searchData.type_id === 2"
                        >
                            <el-upload
                                action=""
                                :show-file-list="false"
                                :http-request="ImportOrder"
                                class="list-upload"
                            >
                                <el-button size="small">导入订单</el-button>
                            </el-upload>
                            <el-button
                                size="small"
                                :disabled="!selectionData.list.length"
                                @click="ExportOrder(null)"
                                >导出订单</el-button
                            >
                            <el-button
                                size="small"
                                :disabled="!selectionData.list.length"
                                @click="ExportOrder(1)"
                                >批量发货</el-button
                            >
                            <el-button
                                size="small"
                                :disabled="!selectionData.list.length"
                                @click="ReconciliationOrder"
                                >批量对账 {{ selectionData.total | $separator }}</el-button
                            >
                        </template>
                    </el-col>
                </el-row>
                <el-alert
                    :title="'已选中 ' + selectionData.list.length + ' 个订单'"
                    type="info"
                    class="list-alert"
                ></el-alert>
                <div class="list-table">
                    <el-table
                        ref="orderTable"
                        :data="orderData.list"
                        stripe
                        class="el-table-custom"
                        style="width: 100%"
                        reserve-selection
                        @selection-change="SelectionOrder"
                        @sort-change="SearchOrder"
                    >
                        <el-table-column
                            type="selection"
                            width="50"
                            :selectable="SelectableOrder"
                        ></el-table-column>
                        <el-table-column label="订单号" min-width="180" fixed="left">
                            <template slot-scope="scope">
                                <el-link
                                    type="primary"
                                    :underline="false"
                                    @click="DetailOrder(scope.row)"
                                    slot="reference"
                                    >{{ scope.row.order_no }}</el-link
                                >
                            </template>
                        </el-table-column>
                        <el-table-column label="客户" min-width="240" fixed="left">
                            <template slot-scope="scope">
                                <el-link
                                    type="primary"
                                    :underline="false"
                                    @click="DetailCustomer(scope.row)"
                                    >{{ scope.row.customer.contact_name }}（{{
                                        scope.row.customer.province
                                    }}）</el-link
                                >
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="回款方式"
                            width="240"
                            v-if="
                                $store.state.userInfo.identity === 1 ||
                                $store.state.userInfo.identity === 2
                            "
                        >
                            <template slot-scope="scope">
                                <el-link type="default" :underline="false">{{
                                    scope.row.pay_id | $pay
                                }}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="订单明细"
                            width="240"
                            v-if="
                                $store.state.userInfo.identity === 1 ||
                                $store.state.userInfo.identity === 2
                            "
                        >
                            <template slot-scope="scope">
                                <el-link
                                    :type="row.modify ? 'danger' : null"
                                    :underline="false"
                                    :key="index"
                                    v-for="(row, index) in scope.row.details"
                                    >{{ row.price | $separator }}（{{ row.product.barcode }}）x
                                    {{ row.num }}{{ row.unit_title }}</el-link
                                >
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="优惠"
                            width="90"
                            v-if="
                                $store.state.userInfo.identity === 1 ||
                                $store.state.userInfo.identity === 2
                            "
                        >
                            <template slot-scope="scope">
                                <template v-if="scope.row.compensate">
                                    <el-link type="danger" :underline="false">{{
                                        scope.row.compensate | $separator
                                    }}</el-link>
                                </template>
                                <template v-else>
                                    <el-link :underline="false"> -- </el-link>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="运费"
                            width="90"
                            v-if="
                                $store.state.userInfo.identity === 1 ||
                                $store.state.userInfo.identity === 2
                            "
                        >
                            <template slot-scope="scope">
                                <template v-if="scope.row.freight">
                                    <el-link type="primary" :underline="false">{{
                                        scope.row.freight | $separator
                                    }}</el-link>
                                </template>
                                <template v-else>
                                    <el-link :underline="false"> -- </el-link>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column label="回款" prop="should" sortable width="120">
                            <template slot-scope="scope">
                                <template v-if="!scope.row.should">
                                    <el-link
                                        :type="
                                            $store.state.userInfo.identity === 1 ? 'danger' : null
                                        "
                                        :underline="false"
                                        >{{ scope.row.should | $separator }}</el-link
                                    >
                                </template>
                                <template v-else>
                                    <el-link type="default" :underline="false">{{
                                        scope.row.should | $separator
                                    }}</el-link>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column label="订单状态" width="120">
                            <template slot-scope="scope">
                                <template v-if="scope.row.deliver_type_id === 2">
                                    <el-tag size="small" type="danger">延迟发货</el-tag>
                                </template>
                                <template v-else>
                                    <template v-if="scope.row.cancel_reason">
                                        <el-tooltip
                                            effect="dark"
                                            :content="scope.row.cancel_reason"
                                        >
                                            <el-tag
                                                size="small"
                                                :type="
                                                    scope.row.order_status_id < 3
                                                        ? 'info'
                                                        : scope.row.order_status_id === 3 ||
                                                          scope.row.order_status_id === 30 ||
                                                          scope.row.order_status_id === 41 ||
                                                          scope.row.order_status_id === 410
                                                        ? 'danger'
                                                        : null
                                                "
                                                >{{ scope.row.order_status_id | $order }}</el-tag
                                            >
                                        </el-tooltip>
                                    </template>
                                    <template v-else>
                                        <el-tag
                                            size="small"
                                            :type="
                                                scope.row.order_status_id < 3
                                                    ? 'info'
                                                    : scope.row.order_status_id === 3 ||
                                                      scope.row.order_status_id === 30 ||
                                                      scope.row.order_status_id === 41 ||
                                                      scope.row.order_status_id === 410
                                                    ? 'danger'
                                                    : null
                                            "
                                            >{{ scope.row.order_status_id | $order }}</el-tag
                                        >
                                    </template>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column label="对账状态" width="120">
                            <template slot-scope="scope">
                                <el-tag
                                    size="small"
                                    :type="!scope.row.is_econciliation ? 'info' : null"
                                    >{{ !scope.row.is_econciliation ? '未完成' : '已完成' }}</el-tag
                                >
                            </template>
                        </el-table-column>
                        <el-table-column label="报单时间" width="180">
                            <template slot-scope="scope">{{
                                scope.row.created_at | $moment('YYYY-MM-DD HH:mm:ss')
                            }}</template>
                        </el-table-column>
                        <el-table-column label="备注" width="240">
                            <template slot-scope="scope">{{ scope.row.memo }}</template>
                        </el-table-column>
                        <el-table-column width="60">
                            <template slot-scope="scope">
                                <div class="t-right">{{ scope.row.order_user.name }}</div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="list-pagination">
                    <el-pagination
                        background
                        layout="total, prev, pager, next, sizes"
                        :current-page.sync="orderData.pages.page"
                        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                        :page-size="orderData.pages.pagesize"
                        :total="orderData.pages.total"
                        @size-change="GetSize"
                        @current-change="GetCurrent"
                    ></el-pagination>
                </div>
            </div>
        </div>

        <v-OrderDetail
            :detailParam="componentParam.orderDetail"
            v-if="componentParam.orderDetail.visible"
        />
        <v-CustomerDetail
            :detailParam="componentParam.customerDetail"
            v-if="componentParam.customerDetail.visible"
        />
    </div>
</template>

<script>
import QRCode from 'qrcode'
import { UserData } from '@/plugin/User'
import OrderDetail from '@/components/order/Detail'
import CustomerDetail from '@/components/customer/Detail'
export default {
    components: {
        'v-OrderDetail': OrderDetail,
        'v-CustomerDetail': CustomerDetail
    },
    inject: ['reload'],
    mixins: [UserData],
    data() {
        return {
            pickerOptions: {
                shortcuts: [
                    {
                        text: '今天',
                        onClick(picker) {
                            const start = new Date(
                                    new Date().getFullYear() +
                                        '-' +
                                        (new Date().getMonth() + 1) +
                                        '-' +
                                        new Date().getDate() +
                                        ' 00:00:00'
                                ),
                                end = new Date(
                                    new Date().getFullYear() +
                                        '-' +
                                        (new Date().getMonth() + 1) +
                                        '-' +
                                        new Date().getDate() +
                                        ' 23:59:59'
                                )
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '昨天',
                        onClick(picker) {
                            const start = new Date(
                                    new Date().getFullYear() +
                                        '-' +
                                        (new Date().getMonth() + 1) +
                                        '-' +
                                        new Date().getDate() +
                                        ' 00:00:00'
                                ),
                                end = new Date(
                                    new Date().getFullYear() +
                                        '-' +
                                        (new Date().getMonth() + 1) +
                                        '-' +
                                        new Date().getDate() +
                                        ' 23:59:59'
                                )
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
                            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近三天',
                        onClick(picker) {
                            const start = new Date(
                                    new Date().getFullYear() +
                                        '-' +
                                        (new Date().getMonth() + 1) +
                                        '-' +
                                        new Date().getDate() +
                                        ' 00:00:00'
                                ),
                                end = new Date(
                                    new Date().getFullYear() +
                                        '-' +
                                        (new Date().getMonth() + 1) +
                                        '-' +
                                        new Date().getDate() +
                                        ' 23:59:59'
                                )
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const start = new Date(
                                    new Date().getFullYear() +
                                        '-' +
                                        (new Date().getMonth() + 1) +
                                        '-' +
                                        new Date().getDate() +
                                        ' 00:00:00'
                                ),
                                end = new Date(
                                    new Date().getFullYear() +
                                        '-' +
                                        (new Date().getMonth() + 1) +
                                        '-' +
                                        new Date().getDate() +
                                        ' 23:59:59'
                                )
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
                            picker.$emit('pick', [start, end])
                        }
                    }
                ]
            },
            userData: {
                list: [],
                pages: {
                    page: 1,
                    pagesize: 9999
                }
            },
            searchData: {
                type_id: 1,
                user_id: null,
                customer_name: null,
                contact_mobilephone: null,
                order_status_id: null,
                is_econciliation: null,
                neq_order_status_id: null,
                deliver_type_id: 1,
                timer: []
            },
            selectionData: {
                total: null,
                list: []
            },
            orderData: {
                loading: {
                    list: []
                },
                list: [],
                pages: {
                    page: 1,
                    pagesize: 10,
                    total: 0
                }
            },
            componentParam: {
                orderDetail: {},
                customerDetail: {}
            }
        }
    },
    created() {
        this.$nextTick(() => {})
    },
    mounted() {
        this.$nextTick(() => {
            this.GetOrder()
        })
    },
    watch: {
        'searchData.type_id'(val) {
            this.searchData.user_id = null
            if (val === 2 && !this.userData.list.length) {
                this.GetUser()
            }
        }
    },
    methods: {
        // 员工
        GetUser() {
            this.GetUserData({
                data: {
                    order: 'asc',
                    ...this.userData.pages
                }
            }).then(res => {
                this.userData.list = res.list
            })
        },
        // 查询
        SearchOrder(column) {
            if (column.order) {
                this.searchData.order_field = column.prop
                this.searchData.order = column.order === 'ascending' ? 'asc' : 'desc'
            } else {
                this.searchData.order_field = 'id'
                this.searchData.order = 'desc'
                this.$refs.orderTable.clearSort()
            }
            this.orderData.pages.page = 0
            this.GetOrder()
        },
        GetOrder() {
            this.orderData.loading.list = true
            this.$request({
                url: '/api/v1/order',
                params: {
                    ...this.searchData,
                    ...this.orderData.pages
                }
            }).then(res => {
                if (!res.status) {
                    this.orderData.loading.list = false
                    res.data.list.forEach(row => {
                        row.details.forEach(detail => {
                            detail.modify = false
                            JSON.parse(detail.product.sku).forEach(sku => {
                                if (detail.unit_id === sku.unit_id && detail.price !== sku.price) {
                                    detail.modify = true
                                }
                            })
                        })
                        return
                    })
                    this.orderData.list = res.data.list
                    this.orderData.pages.total = parseInt(res.data.total)
                } else {
                    this.$message.error(res.message || '操作失败')
                }
            })
        },
        GetSize(val) {
            this.orderData.pages.pagesize = val
            this.GetOrder()
        },
        GetCurrent(val) {
            this.orderData.pages.page = val
            this.GetOrder()
        },
        // 多选
        SelectionOrder(val) {
            this.selectionData.total = null
            this.selectionData.list = []
            if (this.searchData.type_id === 1) {
                if (val.length > 10) {
                    this.$message.error('最多选择10笔订单')
                }
            }
            val.forEach(row => {
                this.selectionData.total += row.should
                this.selectionData.list.push(row.id)
            })

            setTimeout(() => {
                // 生成活码
                const qrcode = document.getElementById('qrcode')
                const url =
                    'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
                    this.$store.state.appid +
                    '&redirect_uri=https://admin.hemutx.com/pay?order_id=' +
                    this.selectionData.list.join(',') +
                    '&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
                QRCode.toCanvas(
                    qrcode,
                    url,
                    { width: 160 },
                    error => {
                        if (error) console.error(error)
                    },
                    200
                )
            })
        },
        // 初始化多选
        SelectableOrder(row) {
            if (
                this.searchData.type_id === 1 &&
                ([11, 12, 51].indexOf(row.pay_id) == -1 || row.is_econciliation)
            ) {
                return false
            } else {
                return true
            }
        },
        // 导出
        ExportOrder(status) {
            this.$axios({
                url: '/api/v1/order_export',
                responseType: 'blob',
                params: {
                    ids: this.selectionData.list,
                    export_status: status || null
                }
            }).then(res => {
                const today = new Date()
                const fileName =
                    '物流订单列表（' +
                    today.getFullYear() +
                    '-' +
                    (today.getMonth() + 1) +
                    '-' +
                    today.getDate() +
                    '）.xls'

                const blob = new Blob([res])
                if ('download' in document.createElement('a')) {
                    const link = document.createElement('a')
                    link.download = fileName
                    link.style.display = 'none'
                    link.href = URL.createObjectURL(blob)
                    document.body.appendChild(link)
                    link.click()
                    URL.revokeObjectURL(link.href)
                    document.body.removeChild(link)
                } else {
                    navigator.msSaveBlob(blob, fileName)
                }
            })
        },
        // 导入
        ImportOrder(obj) {
            var requestData = new FormData()
            requestData.append('report', obj.file)
            this.$request({
                url: '/api/v1/order_import',
                method: 'POST',
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                data: requestData
            }).then(res => {
                this.$message({
                    message: res.message || (res.status ? '操作失败' : '操作成功'),
                    type: res.status ? 'error' : 'success'
                })
                if (!res.status) {
                    this.GetOrder()
                }
            })
        },
        DetailOrder(row) {
            this.componentParam.orderDetail = {
                visible: true,
                row: {
                    id: row.id
                }
            }
        },
        // 客户详情
        DetailCustomer(row) {
            if (row.customer.id) {
                this.componentParam.customerDetail = {
                    visible: true,
                    row: {
                        customer_id: row.customer.id
                    }
                }
            }
        },
        // 批量对账
        ReconciliationOrder() {
            this.$request({
                url: '/api/v1/reconciliation',
                params: {
                    order_id: this.selectionData.list
                }
            }).then(res => {
                if (!res.status) {
                    this.$message({
                        message: res.message || (res.status ? '操作失败' : '操作成功'),
                        type: res.status ? 'error' : 'success'
                    })
                    if (!res.status) {
                        this.reload()
                    }
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/common.less';
@import '~@/assets/css/list.less';
</style>
